import { AsyncViewComponent } from './async-view.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    AsyncViewComponent
  ],
  exports: [
    AsyncViewComponent
  ]
})
export class PplComponentsAsyncViewModule { }
